<template>
  <div class="mystocks">
    <mainmenu selected="mystocks"></mainmenu>

    <div class="container-fluid">
        <h1>{{ $t("mystocks.page_title") }}</h1>
        <div class='card' v-if="$rights.is_not_guest()">
            <div class="card-body" >
                <el-row :gutter="12">
                    <el-col :md="16" :xs="24">
                            <strong>{{$t('mystocks.filters')}}</strong>
                            <el-form label-position="top" label-width="200 px"	>
                                <el-row :gutter="12">
                                    <el-col  :md="8" :xs="24">
                                        <el-form-item :label="$t('dashboard.article_code')">
                                            <el-input v-model="Filters.Name"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col  :md="16" :xs="24">
                                        <el-form-item :label="$t('dashboard.quantity_range')" >
                                            <el-input-number v-model="Filters.MinQuantity"></el-input-number>
                                            -
                                            <el-input-number v-model="Filters.MaxQuantity"></el-input-number>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-button type="primary" @click="refresh_info">{{$t('mystocks.filter')}}</el-button>
                                <el-button type="danger" @click="reset_info">{{$t('mystocks.reset')}}</el-button>
                            </el-form>
                    </el-col>

                    <el-col  :md="8" :xs="24">
                        <strong>{{$t('mystocks.import_from_csv')}}</strong>
                        <el-upload
                            class="upload-demo"
                            ref="upload"
                            :headers="$http.headers.common"
                            :limit="1"
                            :action="$http.options.root + 'mystocks/upload_csv'"
                            :on-success="on_csv_upload_success"
                            :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary">{{ $t('mystocks.choose_csv_file') }}</el-button>
                            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUploadCsv">{{ $t('mystocks.upload_csv_file') }}</el-button>
                            
                            <div slot="tip" class="el-upload__tip">
                                {{$t('mystocks.please_check')}} <a target="_blank" :href="$http.options.root + 'mystocks/get_example_csv'">{{ $t('mystocks.example_csv_file') }}</a>
                                <br/>
                                {{$t('mystocks.columns_used_in_csv')}}
                            </div>

                            <div v-if="upload_errors.length>0">
                                <strong>Errors:</strong>
                                <el-alert v-for="e in upload_errors" :title="'Article Number: ' + e" type="error" :key="e" show-icon> </el-alert>
                            </div>
                        </el-upload>
                    </el-col>
                    
                </el-row>
            </div>
        </div>
        <br/>
        <div class="card">
            <el-table :data="products" style="width: 100%; margin-top: 50px" v-loading="tableLoadingVisible">
                <el-table-column :label="$t('mystocks.product')" width="450">
                    <template slot-scope="scope">
                        <strong>{{scope.row.ArticleNumber}}</strong> - {{scope.row.Name}} <br/>
                        <em>{{scope.row.ProductCategory}}</em> <br/>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('mystocks.first_upload_date')" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.FirstUploadDate != '-1'">{{scope.row.FirstUploadDate}}</span>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('mystocks.last_modified_date')" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.LastModifiedDate != '-1'">{{scope.row.LastModifiedDate}}</span>
                    </template>
                </el-table-column>


                <el-table-column :label="$t('mystocks.description')" >
                    <template slot-scope="scope">
                        {{scope.row.Description}}
                    </template>
                </el-table-column>

                <el-table-column :label="$t('mystocks.used_in_stock')" width="180" fixed="right" >
                    <template slot-scope="scope">
                        <div v-loading="scope.row.used_loading" v-if="$rights.is_not_guest()">
                            <el-button v-if="!scope.row.show_edit_used" 
                                @click="start_edit_used_quantity(scope.row)" 
                                class="btn-stock" type="text">{{scope.row.UsedQuantity}}</el-button>
                            <div v-if="scope.row.show_edit_used" >
                                <el-input-number class="full-width" size="mini" v-model.number="scope.row.UsedQuantity"></el-input-number>
                                <el-row :gutter="5" style="margin-top:10px">
                                    <el-col :span="12"><el-button size="mini" type="danger" @click="cancel_used_quantity(scope.row)" class="full-width">{{$t('cancel')}}</el-button></el-col>
                                    <el-col :span="12"><el-button size="mini" type="primary" @click="save_used_quantity(scope.row)" class="full-width">{{$t('save')}}</el-button></el-col>
                                </el-row>
                            </div>
                        </div>
                        <div v-else>
                            {{scope.row.UsedQuantity}}
                        </div>
                    </template>
                </el-table-column>

            </el-table>
            
        </div>
    </div>
    
  </div>
</template>

<script>
import MainMenu from "./../widgets/MainMenu";
import settings from "./../backend/LocalSettings";

export default {
  name: "categories",
  components: {
    "mainmenu": MainMenu
  },
  data () {
    return { 
      tableLoadingVisible: false,
      products: [],
      Filters: { Name: "", MinQuantity: 0, MaxQuantity: 99000},
      upload_errors: []
    }
  },
  methods: {
      submitUploadCsv() {
        this.$refs.upload.submit();
      },
      save_new_quantity: function( p ){
          this.save_quantity(p, 'new');
      },
      save_used_quantity: function( p ){
          this.save_quantity(p, 'used');
      },
      reset_info: function(){
          this.Filters = { Name: "", MinQuantity: 0, MaxQuantity: 99000};
          this.refresh_info();
      },
      save_price: function( p ){
          p.price_loading  = true;
          this.$http
            .post('mystocks/save_price',  { id_product: p.Id, price: p.Price } )
            .then(function (response) {
                p.price_loading = false;
                if( settings.verify_response(response, this.$rights)) {
                    p.price_loading   = false;
                    p.show_edit_price = false;

                } else {
                    this.$router.push("/");
                }
            });
      },

      save_quantity: function(p, mode="used"){
          if( mode == "used" ) p.used_loading = true;
          if( mode == "new"  ) p.new_loading  = true;

          var quantity = mode=="used" ? p.UsedQuantity : p.NewQuantity;

          this.$http
            .post('mystocks/save_quantity',  { id_product: p.Id, quantity: quantity, mode: mode } )
            .then(function (response) {
                if( settings.verify_response(response, this.$rights)) {
                    if( mode == "used" ) p.show_edit_used = false;
                    if( mode == "new"  ) p.show_edit_new  = false;

                    if( mode == "used" ) p.used_loading = false;
                    if( mode == "new"  ) p.new_loading  = false;

                } else {
                    this.$router.push("/");
                }
            });
      },

      start_edit_price: function( p ){
          p.show_edit_price     = true;
          p.saved_price         = p.Price;
      },
      cancel_edit_price: function( p ){
        p.show_edit_price       = false;
        p.Price                 = p.saved_price;
      },

      start_edit_used_quantity: function(p){
          p.show_edit_used      = true;
          p.saved_used_quantity = p.UsedQuantity;
      },
      start_edit_new_quantity: function(p){
        p.show_edit_new      = true;
        p.saved_new_quantity = p.NewQuantity;
      },
      
      cancel_used_quantity: function( p ){
        p.show_edit_used        = false;
        p.UsedQuantity          = p.saved_used_quantity;
      },
      cancel_new_quantity: function( p ){
        p.show_edit_new         = false;
        p.NewQuantity           = p.saved_new_quantity;
      },

      refresh_info: function() {
        this.tableLoadingVisible = true;
        this.$http
          .post('mystocks/refresh_info',  { Filters: this.Filters } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.products       = response.body.products;
              this.PaginationInfo = response.body.PaginationInfo;
            } else {
              this.$router.push("/");
            }
          });
      },
      on_csv_upload_success: function(response, file, fileList)
      {
        this.upload_errors = response.Errors;
        if( this.upload_errors.length == 0 )
        {
            this.$message( this.$t('stocks_updated_with_success') );
        }
        //
        this.refresh_info();
        this.$refs.upload.clearFiles();
      }
   
  },
  mounted: function() {
    this.refresh_info();
  }
};
</script>

<style lang="less" scoped>
    .el-form-item__label
    {
        text-align: left !important; 
        float: none !important;
    }
    .btn-stock{
        display: inline-block;
        width: 100%;
        border-bottom: 1px dotted gray;
    }
    th{
        padding: 2px;
    }
    .qty-col{
        width: 220px;
    }
    .full-width{
        width: 100%;
    }
    .article-code{
        font-size: 10px;
        font-weight: bold;
    }

</style>